/**
 * The owner's questions, folded out of the ledger the shell already reads.
 *
 * Nothing here fetches and nothing here draws: what is left names the rows
 * `/api/timeline` is asked for, and answers whether one of them is something a
 * person asked for. One rule both keep: say only what the rows say. A turn that
 * finished having been asked nothing is nobody's question rather than an
 * invented one.
 */

/** The core's own words for the events read here (`workbench/server/protocol.py`). */
export const KIND_INBOUND = "l0.inbound";
export const KIND_TURN_FINAL = "l0.turn_final";
export const KIND_TOOL_CALL = "l0.tool_call";
export const KIND_TOOL_RESULT = "l0.tool_result";
export const KIND_EFFECT_HELD = "l0.effect.held";
export const KIND_EFFECT_RELEASED = "l0.effect.released";

/**
 * The kinds above, as the query a Studio page sends.
 *
 * Asking for a plain `limit` gets the last N rows of everything, and on a real
 * core almost all of them are `registry` -- a from-zero instance writes over
 * 1600 registry rows before anybody says a word, so an unfiltered window of 300
 * reached back about ninety seconds and 今天 reported two finished turns out of
 * twenty-four. The endpoint takes `kind` repeatably (`app.py` `/api/timeline`),
 * so the window is 300 of the rows these folds actually read.
 */
export function studioWindow(limit: number): URLSearchParams {
  const params = new URLSearchParams({ limit: String(limit) });
  for (const kind of [
    KIND_INBOUND,
    KIND_TURN_FINAL,
    KIND_TOOL_CALL,
    KIND_TOOL_RESULT,
    KIND_EFFECT_HELD,
    KIND_EFFECT_RELEASED,
  ]) {
    params.append("kind", kind);
  }
  return params;
}

/** 原始人类交代或日程到点的工作；续接继承 human 也不是新的交代。 */
export function askedByAnyone(row: Record<string, unknown>): boolean {
  const cause = text(row.cause);
  if (cause === "due") return true;
  return text(row.origin) === "human" && cause === "channel" && text(row.dispatch_mode) === "turn";
}

function text(value: unknown): string {
  return typeof value === "string" ? value : "";
}
